// extracted by mini-css-extract-plugin
export default {"promotionsBlock":"style_promotionsBlock__p67w-","newsProdBlck":"style_newsProdBlck__NVxB5","name":"style_name__AalNc","promImg":"style_promImg__p7jT0"};